<template lang="html">


  <div class="wrapper margin-menu">

    <section class="intro column-center -fundacion">
      <h2>La Fundación</h2>
      <h1>Fundadores y miembros</h1>
    </section>

    <section class="breadcrumb">
      <nav class="container row-end">
        <router-link to="/">Inicio</router-link>
        <router-link :to="$t('enlaces.lafundacion')">La Fundación</router-link>
        <router-link :to="$t('enlaces.fundadores')">Fundadores y miembros</router-link>
      </nav>
    </section>

    <main>

      <div class="container">

        <h2 class="title-intro">
          <strong>Los fundadores</strong>
        </h2>

        <p class="texto-intro">
          A través de la Fundación, la familia Pascual Gómez-Cuétara se involucra directamente en el objetivo de mejorar la calidad de vida de las personas. La Fundación nació con este firme propósito y está integrada directamente por los miembros de la primera y segunda generación de la familia y con una participación activa de miembros de la tercera generación en los proyectos.
        </p>

      </div>

      <div class="contenedor-fundadores">

        
        <div class="container">
          
          <h2 class="big-title">Fundadores</h2>
          <div class="fundador row-start ais -donapilar">
            <div class="imagen row-end">
              <img src="/static/img/foto-pilar.png" alt="Doña Pilar Gómez-Cuétara Fernández">
            </div>
            <div class="texto" :show="showmore.pilar">
              <h2>Doña Pilar Gómez-Cuétara Fernández</h2>
              <p>Pilar Gómez-Cuétara Fernández, Presidenta de la Corporación Empresarial Pascual, nace en México D.F. el 21 de Agosto de 1940, siendo la tercera de once hermanos (9 mujeres y 2
                hombres).</p>
              <p>En 1935, su padre, Florencio Gómez-Cuétara, junto con su tío, Juan Gómez-Cuétara, fundan una industria galletera en México. Tras el éxito obtenido durante los 10 primeros años, los
                fundadores regresan a España para crear en 1951 una filial,</p>
              <p>Gómez Cuétara Hermanos, en Reinosa (Cantabria), trasladando allí la experiencia americana. En 1964 pasó a llamarse Cuétara, S.A.</p>
              <p class="hide">De joven trabaja en la confitería familiar, donde conoce a Tomás Pascual Sanz. Completa su experiencia profesional con estudios de idiomas en Irlanda.</p>

              <p class="hide">Contrae matrimonio a la edad de 21 años con Tomás Pascual Sanz. Tienen 4 hijos (Tomás, Pilar, Sonia y Borja) y, actualmente, 14 nietos.</p>

              <p class="hide">Acompañante habitual en los viajes profesionales de Tomás Pascual Sanz, aprende de primera mano los secretos de los negocios familiares.</p>

              <p class="hide">Actualmente, desde su posición de Presidenta de la Corporación Empresarial Pascual, colabora activamente en tareas representativas y de responsabilidad social.</p>

              <a @click="showmore.pilar= !showmore.pilar" class="show-more">{{(showmore.pilar) ? '-' : '+'}}</a>
            </div>
          </div>

          <div class="fundador row-start ais">
            <div class="texto" :show="showmore.dontomas">
              <h2>Don Tomás Pascual Sanz</h2>

              <p>Tomás Pascual Sanz nació en Fuentemizarra (Segovia) el 20 de Diciembre de 1926 y falleció en Madrid el 16 de Febrero de 2006. Presidente fundador de Calidad Pascual S.A.U., creó uno
                de los grupos alimentarios más importantes de España.</p>

              <p>Procedente de una familia de comerciantes, abandona los estudios a muy temprana edad a causa de la guerra civil. La familia se asienta en Aranda de Duero (Burgos), después de que la
                construcción de un pantano les obligara a dejar Linares del Arroyo (Segovia), donde vivían. Desde entonces trabajó en la cantina que regentaba su padre, caracterizándose desde muy
                joven por un marcado espíritu emprendedor.</p>

              <p class="hide">Siendo el más pequeño de nueve hermanos, lideró la sociedad que se constituye en 1950 con el nombre de Pascual Hermanos, que se dedicaba a la distribución de piensos. En
                1959 toma la iniciativa con la construcción de una fábrica de piensos compuestos para, en 1966, crear la sociedad Pascual Aranda, dedicada a la cría de aves, cría porcina y bovina. La
                Caja de Ahorros Municipal de Burgos le ofrece en 1969 hacerse cargo de una fábrica de leche en quiebra. Tomás Pascual Sanz acepta el reto y, con la denominación inicial de Industrias
                Lácteas Pascual, S.A., sienta las bases del actual Calidad Pascual S.A.U.</p>

              <p class="hide">La asociación de la marca con la alta calidad, no sólo de la leche sino también del resto de sus productos comercializados, fue uno de los empeños confesados de
                Tomás Pascual Sanz, por ello el eslogan “La calidad nuestra razón de ser”.</p>


              <a @click="showmore.dontomas= !showmore.dontomas" class="show-more">{{(showmore.dontomas) ? '-' : '+'}}</a>
            </div>
            <div class="imagen row-start">
              <img src="/static/img/foto-don-tomas.png" alt="Don Tomás Pascual Sanz">
            </div>
          </div>

        </div>

      </div>


      <div class="contenedor-fundadores -gray">


        <div class="container">
          <h2 class="big-title -white">Miembros</h2>
          <div class="fundador row-start ais">
            <div class="texto" :show="showmore.tomas">
              <h2>Tomás Pascual Gómez-Cuétara</h2>
              <p>Tomás Pascual Gómez Cuétara es el hijo primogénito del matrimonio entre Tomás Pascual y Pilar Gómez-Cuétara. En la actualidad es Presidente de Calidad Pascual, cargo que ocupa desde marzo de 2006, así como del holding empresarial que aglutina todos los negocios de la familia Pascual Gómez-Cuétara, la Corporación Empresarial Pascual.</p>

              <p class="hide">Más de 30 años de experiencia en la compañía le otorgan un conocimiento profundo de la misma. Empezando por la experiencia inicial en tareas de almacén, gran logística y comerciales, hasta el pilotaje de la estrategia en los últimos años.</p>

              <p class="hide">Es ingeniero industrial por la Universidad Politécnica de Madrid y posee formación en instituciones americanas de prestigio como la compañía alimentaria neoyorkina White Rock y el Bank of America, así como un MBA en el Massachusetts Institute of Technology.</p>
              <p class="hide">Regresó en 1991 para incorporarse a la empresa familiar. Ha sido presidente durante 6 años de la Federación Española de Industrias de Alimentación y Bebidas y el año 2022 fue nombrado presidente del Club Excelencia en Gestión. Como su padre, es un trabajador incansable y una persona curiosa e inquieta. Amante del cine, apasionado de la música y de su familia, con la que trata de pasar el mayor tiempo posible.</p>


              <a @click="showmore.tomas= !showmore.tomas" class="show-more">{{(showmore.tomas) ? '-' : '+'}}</a>
            </div>
          </div>

          <div class="fundador row-end ais">
            <div class="texto" :show="showmore.pilar">
              <h2>Pilar Pascual Gómez-Cuétara</h2>
              <p>Pilar Pascual Gómez-Cuétara nació en Santander y es la segunda de los hijos del matrimonio formado por Tomás Pascual y Pilar Gómez-Cuétara. Nieta de empresarios de Cantabria y de Castilla a los 16 años comenzó su gran proyecto empresarial: su propio hogar. Este negocio le hizo avanzar en sus 3 grandes pasiones: la familia, el emprendimiento y su vocación filantrópica.</p>

              <p class="hide">Como accionista de la Corporación Empresarial Pascual, es miembro desde 1999 del Consejo de Familia y del Consejo Corporativo, cargos que ocupa en la actualidad. Desde entonces su trabajo se ha centrado en el legado y la continuidad de la empresa familiar.</p>

              <p class="hide">Como resultado se crearon Club Teype, una oficina familiar para atender las necesidades de la familia, y la Fundación Tomás Pascual y Pilar Gómez-Cuétara, de la cual es presidenta y que tiene como principal misión dar continuidad y fomentar los principios que fueron transmitidos por la familia empresaria.</p>
              <p class="hide">
                En 2007 fue miembro del equipo fundador que creó CIVSEM - Centro de Investigación en Valores-, el principal proyecto de la fundación familiar, y ahora continúa siendo presidenta. Su objetivo es desarrollar los valores humanos en la sociedad y las empresas. Esto le permite cumplir con su vocación emprendedora y filantrópica.
              </p>
              <a @click="showmore.pilar= !showmore.pilar" class="show-more">{{(showmore.pilar) ? '-' : '+'}}</a>
            </div>
          </div>

          <div class="fundador row-start ais">
            <div class="texto" :show="showmore.sonia">
              <h2>Sonia Pascual Gómez-Cuétara</h2>
              <p>Es la tercera de los cuatro hijos de Tomás Pascual y Pilar Gómez-Cuétara y ocupa el cargo de consejera de la Corporación Empresarial Pascual. Asimismo, es secretaria del Consejo de Familia, constituido a raíz de la elaboración del Protocolo Familiar, así como miembro de la Comisión de Sostenibilidad del Consejo de Administración de Calidad Pascual.</p>

              <p class="hide">Sonia es Licenciada en Derecho por la Universidad Complutense de Madrid, posee un Programa de Dirección General (PDG) por el IESE, es también consteladora familiar y, al igual que su hermana Pilar, es coach titulada. Impulsó la creación de la Fundación Tomás Pascual y Pilar Gómez-Cuétara con la vocación de acercar la realidad social al mundo de la empresa, y, a la vez, formar futuros profesionales y personas íntegras.</p>

              <p class="hide">Presidenta de Club Teype (oficina de familia), sus tareas dentro de la empresa familiar se centran en la comunicación, la formación y la educación de la familia. Amante de la vida familiar y de viajar, tiene 3 hijos y le gusta pasar tiempo junto a sus seres queridos. Es muy extrovertida y suele representar a la Corporación Empresarial Pascual y a su familia en numerosos actos públicos.</p>
              <a @click="showmore.sonia= !showmore.sonia" class="show-more">{{(showmore.sonia) ? '-' : '+'}}</a>
            </div>
          </div>

          <div class="fundador row-end ais">
            <div class="texto" :show="showmore.borja">
              <h2>Borja Pascual Gómez-Cuétara</h2>
              <p>Borja Pascual Gómez-Cuétara es el hijo menor de los fundadores de la Corporación Empresarial Pascual. Es miembro de la Junta Directiva de Calidad Pascual y del Consejo de Familia de la Empresa familiar. Además, es CEO de Kampinas, la rama inmobiliaria de la empresa familiar, más conocida Grupo Inmobiliario La Quinta, ubicada en Benahavís (Málaga, España).</p>

              <p class="hide">Borja Pascual se incorporó a la empresa familiar en 2006, tras finalizar su carrera internacional formación y concluir su experiencia profesional en otras empresas.</p>
              
              <p class="hide">En lo que respecta a su formación universitaria, es Licenciado en Administración y Dirección de empresas por la Universidad Complutense de Madrid y Máster en Ciencias en Desarrollo Inmobiliario por la Universidad de Columbia.</p>
              
              <p class="hide">En cuanto a su perfil personal, es muy aficionado a la música y a los deportes de aventura como el esquí y la escalada de montaña.</p>
              <a @click="showmore.borja= !showmore.borja" class="show-more">{{(showmore.borja) ? '-' : '+'}}</a>
            </div>
          </div>

        </div>

      </div>




    </main>

  </div>

</template>

<script lang="js">
  
  
  export default {
    name: 'fundadores',
    data(){
      return{
        showmore:{
          donapilar : false,
          dontomas : false, 
          tomas : false, 
          pilar : false,
          sonia : false,
          borja : false
        }
      }
    }
  }
    
  </script>
<style lang="scss">
  
  </style>


// WEBPACK FOOTER //
// src/components/views/fundadores.vue